$(".accordion__title").click(function () {
  if ($('.accordion__content').is(':visible')) {
    $(".accordion__content").slideUp(300);
    $(".plusminus").text('+');
  }
  if ($(this).next(".accordion__content").is(':visible')) {
    $(this).next(".accordion__content").slideUp(300);
    $(this).children(".plusminus").text('+');
  } else {
    $(this).next(".accordion__content").slideDown(300);
    $(this).children(".plusminus").text('-');
  }
});
/*
$(".accordion__title").click(function() {
  const $accordion_wrapper = $(this).parent();
  const $accordion_content = $(this).parent().find(".accordion__content").first();
  const $accordion_open = "accordion--open";

$(".accordion").css("style", "")

  // If this accordion is already open
  if ($accordion_wrapper.hasClass($accordion_open)) {
    $accordion_content.slideUp();                     // Close the content.
    $accordion_wrapper.removeClass($accordion_open);  // Remove the accordionm--open class.
  }
  // If this accordion is not already open
  else {
    $accordion_content.slideDown();                 // Show this accordion's content.
    $accordion_wrapper.addClass($accordion_open);   // Add the accordion--open class.
  }
});
*/
jQuery(document).ready(function ($) {
  if (document.querySelector('.slider-fors')) {
  $('.slider-fors').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-navs'
  });
  }

  if (document.querySelector('.slider-navs')) {
    $('.slider-navs').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.slider-fors',
      dots: false,
      prevArrow: '<span class="slide-arrow prev-arrow"></span>',
      nextArrow: '<span class="slide-arrow next-arrow"></span>',
      centerMode: true,
      focusOnSelect: true
    });
  }
});

// document.querySelector(".slider-fors .slick-slide").style.removeProperty("width");

$(".set > a").on("click", function () {
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
    $(this)
      .siblings(".content")
      .slideUp(200);
    $(".set > a i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
  } else {
    $(".set > a i")
      .removeClass("fa-minus")
      .addClass("fa-plus");
    $(this)
      .find("i")
      .removeClass("fa-plus")
      .addClass("fa-minus");
    $(".set > a").removeClass("active");
    $(this).addClass("active");
    $(".content").slideUp(200);
    $(this)
      .siblings(".content")
      .slideDown(200);
  }
});


/*FAQ*/
/*
    $('.accordion').click(function(){

      var isActive = $(this).hasClass("active");
			$('.accordion').removeClass('active')
      if (!isActive) {
        $(this).toggleClass('active');
      }

      $(this).next().slideToggle('fast');
      //Hide the other panels
      $(".panel").not($(this).next()).slideUp('fast');

    }); */


// Get the modal
var modal = document.getElementById("myModal");

// Get the button that opens the modal
var btn = document.getElementById("myBtn");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close1")[0];

// When the user clicks the button, open the modal
if (btn) {
  btn.onclick = function click() {
    modal.style.display = "block";
  }
}

// When the user clicks on <span> (x), close the modal
if (span) {
  span.onclick = function click() {
    modal.style.display = "none";
  }
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}

// Get the modal
var modals = document.getElementById("myModal2");

// Get the button that opens the modal
var btns = document.getElementById("myBtn2");

// Get the <span> element that closes the modal
var spans = document.getElementsByClassName("close2")[0];

// When the user clicks the button, open the modal
if (btns) {
  btns.onclick = function click() {
    modals.style.display = "block";
  }
}

// When the user clicks on <span> (x), close the modal
if (spans) {
  spans.onclick = function click() {
    modals.style.display = "none";
  }
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
  if (event.target == modals) {
    modals.style.display = "none";
  }
}
















